export enum GwrStatus {
  OK = 100,
  NORESULTS = 101
}
